import React from 'react';
import {connect} from 'react-redux';
import {change} from 'redux-form';
import {
    Edit,
    SimpleForm,
    TextInput,
    NumberInput,
    SelectInput,
    BooleanInput,
    required,
    minValue,
    maxValue,
} from 'react-admin';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {
    dripCampaignWizardInitialize,
    dripCampaignWizardSave
} from '../../actions/dripCampaignActions';
import {
    dripCampaignSelectCampaign,
    dripCampaignSelectWizard,
    dripCampaignSelectWizardLoading,
    dripCampaignSelectMessages,
    dripCampaignSelectGroups,
    dripCampaignSelectSenders
} from '../../selectors/dripCampaignSelector';
import DripCampaignToolbar from './DripCampaignToolbar';
import DripCampaignFilters from './DripCampaignFilters';

class DripCampaignEdit extends React.Component {
    componentDidMount() {
        const {wizard, wizardInitialize} = this.props;

        if (!wizard.initialized) {
            wizardInitialize();
        }
    }

    render() {
        const {dripCampaign, change, dispatch, save, wizard, wizardLoading, wizardInitialize, messages, groups, senders, t, tReady, ...rest} = this.props;

        return (
            <Edit {...rest} title={t('drip.edit_title')}>
                <SimpleForm
                    toolbar={<DripCampaignToolbar save={save} saving={(wizard && wizard.saving) || wizardLoading || false} />}
                >
                    <TextInput
                        source="name"
                        label={t('drip.name')}
                        validate={[required()]}
                        fullWidth
                    />

                    <TextInput
                        source="subject"
                        label={t('drip.subject')}
                        validate={[required()]}
                        helperText={t('drip.subject_help')}
                        fullWidth
                    />

                    <SelectInput
                        source="sender"
                        label={t('drip.sender')}
                        choices={senders}
                        optionText={(sender) => sender.name ? `${sender.name} <${sender.email}>` : sender.email}
                        optionValue="id"
                        validate={[required()]}
                        helperText={t('drip.sender_help')}
                        fullWidth
                    />

                    <SelectInput
                        source="message"
                        label={t('drip.base_campaign')}
                        choices={messages}
                        optionText="name"
                        optionValue="id"
                        validate={[required()]}
                        fullWidth
                    />

                    <BooleanInput
                        source="retakeSnapshot"
                        label={t('drip.retake_snapshot')}
                        helperText={t('drip.retake_snapshot_help')}
                        defaultValue={false}
                    />

                    <SelectInput
                        source="targetGroup"
                        label={t('drip.target_group')}
                        choices={groups}
                        optionText="name"
                        optionValue="id"
                        validate={[required()]}
                        helperText={t('drip.target_group_help')}
                        fullWidth
                    />

                    <SelectInput
                        source="triggerType"
                        label={t('drip.trigger_type')}
                        choices={[
                            { id: 'contact_created', name: t('drip.trigger.contact_created') },
                            { id: 'contact_updated', name: t('drip.trigger.contact_updated') },
                            { id: 'manual_enrollment', name: t('drip.trigger.manual_enrollment') },
                        ]}
                        validate={[required()]}
                        helperText={t('drip.trigger_type_help')}
                        fullWidth
                    />

                    <NumberInput
                        source="delayInHours"
                        label={t('drip.delay_in_hours')}
                        validate={[required(), minValue(1), maxValue(8760)]}
                        helperText={t('drip.delay_in_hours_help')}
                        fullWidth
                    />

                    <BooleanInput
                        source="isActive"
                        label={t('drip.is_active')}
                        defaultValue={true}
                    />

                    <DripCampaignFilters/>
                </SimpleForm>
            </Edit>
        );
    }
}

DripCampaignEdit.propTypes = {
    dripCampaign: PropTypes.object.isRequired,
    change: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
    wizard: PropTypes.object.isRequired,
    wizardInitialize: PropTypes.func.isRequired,
    messages: PropTypes.array.isRequired,
    groups: PropTypes.array.isRequired,
    senders: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        dripCampaign: dripCampaignSelectCampaign(state),
        wizard: dripCampaignSelectWizard(state),
        wizardLoading: dripCampaignSelectWizardLoading(state),
        messages: dripCampaignSelectMessages(state),
        groups: dripCampaignSelectGroups(state),
        senders: dripCampaignSelectSenders(state),
    }
};

const mapDispatchToProps = dispatch => {
    return {
        change: (field, value) => dispatch(change('record-form', field, value)),
        save: () => dispatch(dripCampaignWizardSave('list')),
        wizardInitialize: () => dispatch(dripCampaignWizardInitialize()),
    }
};

const DripCampaignEditWithTranslation = (props) => {
    const {t} = useTranslation();
    return <DripCampaignEdit {...props} t={t} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(DripCampaignEditWithTranslation);